import { COMPONENT_NAME } from '@jusbrasil-web/shared-ga4-events'
import { useEffect } from 'react'

import successImgSrc from '../../../assets/cpf-validation/success.svg'
import { COMPONENT_RENDER_EVENT_PROPS, GA4EventHandlers } from '../../../hooks'
import { useIdDocumentValidationContext } from '../context'
import { DocumentStaticStep } from './document-static-step'

interface IdentitySuccessProps {
  onClose?: () => void
  gA4EventHandlers?: GA4EventHandlers
}

export function IdentitySuccess(props: IdentitySuccessProps) {
  const { onClose, gA4EventHandlers } = props
  const { texts } = useIdDocumentValidationContext()

  const title = texts?.identitySuccess?.title ?? 'Identidade verificada'
  const bodyText = texts?.identitySuccess?.bodyText ?? 'Seu documento foi verificado com sucesso.'
  const buttonText = texts?.identitySuccess?.buttonText ?? 'Continuar'

  useEffect(() => {
    gA4EventHandlers?.sendComponentRender({
      componentClass: null,
      componentName: COMPONENT_NAME.DOCUMENT_VALIDATION,
      renders: COMPONENT_RENDER_EVENT_PROPS.IDENTITY_SUCCESS,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <DocumentStaticStep
      testId="identity-success-step"
      imageSrc={successImgSrc}
      title={title}
      bodyText={bodyText}
      action={{
        onClick: onClose,
        label: buttonText,
      }}
      onLoadEvent={{
        name: 'UserAccount.IdValidationSuccessViewed',
      }}
    />
  )
}
